// extracted by mini-css-extract-plugin
module.exports = {"root":"bj_bk","icon":"bj_bs","main-search-icon":"bj_dz","mainSearchIcon":"bj_dz","label-icon-default-filled":"bj_dB","labelIconDefaultFilled":"bj_dB"};